function formatArgentinePhone(phone) {
  const s = phone.replace(/^\+*|\s/g, "");

  // Formato viejo de CABA: 15XXXXXXXX (10 dígitos, sin código de área)
  // 15 nunca es un código de área → se mapea a 11XXXXXXXX
  if (/^15\d{8}$/.test(s)) {
    return `54911${s.slice(2)}`;
  }

  const withoutPrefixes = s.replace(/^(0|15|54(?!9))/, "");
  return withoutPrefixes.startsWith("549") ? withoutPrefixes : `549${withoutPrefixes}`;
}

export function isValidArgentineMobile(phone) {
  if (!phone) return false;
  const cleaned = phone.replace(/^\+*|\s/g, "");
  if (!/^\d+$/.test(cleaned)) return false;
  return formatArgentinePhone(phone).length === 13;
}
